import type {ReactNode} from 'react';
import {
  PopoutWindowContext,
  type PopoutWindowContextValue,
} from './PopoutWindowContext';

export interface PopoutWindowProviderProps {
  children: ReactNode;
  popoutWindow: Window;
  popoutDocument: Document;
  popoutId: string;
}

// ----------------------------
// PopoutWindowProvider
// ----------------------------
export const PopoutWindowProvider = ({
  children,
  popoutWindow,
  popoutDocument,
  popoutId,
}: PopoutWindowProviderProps): ReactNode => {
  const value: PopoutWindowContextValue = {
    popoutWindow,
    popoutDocument,
    isInPopout: true,
    popoutId,
  };

  return (
    <PopoutWindowContext.Provider value={value}>
      {children}
    </PopoutWindowContext.Provider>
  );
};

export default PopoutWindowProvider;
